"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/OrgRels/NewOrgRow/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _reacthookform = require('react-hook-form');

var _org = require('shared/validation/org/org');
var _org3 = require('shared/hooks/org');
var _string = require('shared/services/string');

var _Form = require('web/components/Form');
var _AuthFrame = require('web/components/AuthFrame');








// Create-mode org row: a plain name input with no search results. We still look
// up organizations in the background so we can nudge the user toward joining an
// existing team when the name they typed already exists (duplicate-org guard).
const NewOrgRow = ({ idx, control, display, onSwitchToJoin }) => {
  const orgValue = _reacthookform.useWatch.call(void 0, { control, name: `orgs.${idx}.org` })
  const typedName = typeof orgValue === 'string' ? orgValue : ''

  const { lookupOrgs } = _org3.useOrgLookup.call(void 0, typedName, _org.MIN_ORG_NAME_SEARCH_LENGTH)
  const hasExistingMatch = _react.useMemo.call(void 0, 
    // Normalized exact match only (trim + case-insensitive); a substring
    // near-match must not fire the guard.
    () => lookupOrgs.some(o => _string.compareStr.call(void 0, _string.sanitizeStr.call(void 0, typedName), _string.sanitizeStr.call(void 0, o.Name)) === 0),
    [lookupOrgs, typedName],
  )

  return (
    _react2.default.createElement('div', { className: "signup--org-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
      , _react2.default.createElement(_reacthookform.Controller, {
        control: control,
        name: `orgs.${idx}.org`,
        render: ({ field }) => (
          _react2.default.createElement(_Form.InputSectionWrapper, { title: "Organization", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
            , _react2.default.createElement(_Form.TextInput, {
              value: field.value ,
              placeholder: "E.g. Sunrise Family Clinic"   ,
              onChange: e => { display.onType(`orgs.${idx}.org`); field.onChange(e) },
              onBlur: () => { display.onLeave(`orgs.${idx}.org`, field.value); field.onBlur() },
              hasError: !!display.shown(`orgs.${idx}.org`), __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
            )
            ,  hasExistingMatch && (
              _react2.default.createElement('p', { className: "auth-note signup--org-dupe-notice" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
                , _react2.default.createElement(_AuthFrame.InfoIcon, { className: "auth-note--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}} )
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}, "This organization already exists."
                     , ' '
                  , _react2.default.createElement('button', { type: "button", className: "auth-link", onClick: () => onSwitchToJoin(typedName), __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Request to join instead?"

                  )
                )
              )
            )
          )
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
      )
      , _react2.default.createElement(_reacthookform.Controller, {
        control: control,
        name: `orgs.${idx}.title`,
        render: ({ field }) => (
          _react2.default.createElement(_Form.InputSectionWrapper, { title: "Your title" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
            , _react2.default.createElement(_Form.TextInput, {
              value: field.value,
              placeholder: "E.g. Head Nurse"  ,
              onChange: e => { display.onType(`orgs.${idx}.title`); field.onChange(e) },
              onBlur: () => { display.onLeave(`orgs.${idx}.title`, field.value); field.onBlur() },
              hasError: !!display.shown(`orgs.${idx}.title`), __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
            )
          )
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
      )
    )
  )
}

exports. default = NewOrgRow
